import { createFeature, createReducer, on } from '@ngrx/store';

import { ContainerMeasurement } from 'app/features/manual-input-result-registration/models/container-measurement';
import { Credentials, error, getInitialProgressState, ProgressState, running } from 'app/shared/models';

import {
    addContainerMeasurementsToCache,
    resetContainerMeasurementState,
    sendCachedContainerMeasurements,
    sendCachedContainerMeasurementsFailure,
    sendCachedContainerMeasurementsSuccess,
} from './container-measurements.actions';

export const containerMeasurementsFeatureKeys = 'containerMeasurements';

export interface ContainerMeasurementState {
    cachedContainerMeasurements: { [key: number]: ContainerMeasurement };
    cachedContainerMeasurementCounter: number;
    sendProgress: ProgressState;
    previousUserSessionCredentials: Credentials | undefined;
}

export const initialState: ContainerMeasurementState = {
    cachedContainerMeasurements: [],
    cachedContainerMeasurementCounter: 0,
    sendProgress: getInitialProgressState(),
    previousUserSessionCredentials: undefined,
};

export const reducer = createReducer(
    initialState,
    on(addContainerMeasurementsToCache, (state, action) => {
        const newCachedContainerMeasurements: { [key: number]: ContainerMeasurement } = {};
        let cachedContainerMeasurementCounter = state.cachedContainerMeasurementCounter;
        for (const containerMeasurement of action.containerMeasurements) {
            newCachedContainerMeasurements[cachedContainerMeasurementCounter++] = containerMeasurement;
        }
        return {
            ...state,
            cachedContainerMeasurements: {
                ...state.cachedContainerMeasurements,
                ...newCachedContainerMeasurements,
            },
            cachedContainerMeasurementCounter,
        };
    }),
    on(sendCachedContainerMeasurements, (state) => ({
        ...state,
        sendProgress: running(),
    })),
    on(sendCachedContainerMeasurementsSuccess, (state, { sentContainerMeasurements }) => {
        const sentContainerMeasurementKeys = Object.keys(sentContainerMeasurements).map(Number);
        const newCachedContainerMeasurements = { ...state.cachedContainerMeasurements };

        for (const sentContainerMeasurementKey of sentContainerMeasurementKeys) {
            delete newCachedContainerMeasurements[sentContainerMeasurementKey];
        }

        const cachedContainerMeasurementCounter = Object.keys(newCachedContainerMeasurements).length
            ? state.cachedContainerMeasurementCounter
            : 0;

        return {
            ...state,
            cachedContainerMeasurementCounter,
            cachedContainerMeasurements: newCachedContainerMeasurements,
        };
    }),
    on(sendCachedContainerMeasurementsFailure, (state, { errorMessage }) => ({
        ...state,
        sendProgress: error(errorMessage),
    })),
    on(resetContainerMeasurementState, () => ({
        ...initialState,
    })),
);

export const containerMeasurementFeature = createFeature({
    name: containerMeasurementsFeatureKeys,
    reducer,
});
